import React, { useEffect, useState } from "react";
import API from "../../services/api";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import "react-json-view-lite/dist/index.css";
import { Toast } from "../../shared/Toast";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router";
import { languageOptions, stateOptions, fetchMatchAdCodeAlert, slotOptions } from "../../utils/constants";
import { formatDateWithTime } from "../../utils/dateFormat";
import TargetPreview from "./TargetPreview";
import DeleteSvg from "../../assets/images/delete_icon.svg";
import CloseCrosssvg from "../../assets/images/close_cross_icon.svg";
import Select from 'react-select'
import LineitemPreview from "../campaign/LineitemPreview";

function InternalAds(props) {
  const navigate = useNavigate();
  const [internalAds, setInternalAds] = useState([]);
  const [loader, setLoader] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [removeData, setRemoveData] = useState({});
  const [showRemoveAlert, setShowRemoveAlert] = useState(false);
  const [add, setAdd] = useState(false);
  const [lineItemData, setLineItemData] = useState([]);
  const [existingData, setExistingData] = useState([]);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [removeClicked, setRemoveClicked] = useState(false);
  const [target_filter, setTarget_filter] = useState({
    lang_id: "1",
    state_id: "-1",
    district_id: "-1",
    mandal_id: "-1",
    village_id: "-1",
    zone_id: "-1",
  });
  const [districtfilter, setDistrictfilter] = useState([]);
  const [mandalFilter, setMandalfilter] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [adIds, setAdIds] = useState([]);
  const [hiddens, setHiddens] = useState([]);
  const [hidden, setHidden] = useState();
  const [formData, setFormData] = useState();
  const [formSubmit, setFormSubmit] = useState(false);
  const [previewCampaignId, setPreviewCampaignId] = useState(null)
  const [matchAdCodeAlert, setMatchAdCodeAlert] = useState({});

  const form1 = useForm({ mode: "onSubmit" });
  const language = form1.getValues("lang_id");
  if (!language) form1.setValue("lang_id", "1");
  const watchLang = form1.watch("lang_id", "1");
  let watchState = form1.watch("state_id");
  let watchDist = form1.watch("district_id");
  let watchMandal = form1.watch("mandal_id");
  let watchZone = form1.watch("zone_id");
  const fetchInternalAds = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "adunit/getInternalCamps",
        method: "POST",
        responseType: "json",
        data: {
          internalCampIds: adIds,
        },
      });
      if (res.code === 200) {
        let data = [];
        let ind = 0;
        res.data.map((item) => {
          item["hidden"] = hiddens[ind];
          ind++;
          data.push(item);
        });
        setInternalAds(data);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleClose = () => {
    props.setShow(false);
    props.setPosition(false);
  };

  const setDataFields = () => {
    let ids = [];
    let hiddens = [];
    props.internalAds.map((item) => {
      ids.push(item.campaign_id);
      hiddens.push(item.hidden);
    });
    setAdIds(ids);
    setHiddens(hiddens);
  };

  const removeFromPosition = async (data) => {
    let obj = { ...data };
    obj.campaign_name = undefined;

    try {
      let res = await API({
        url: "/adunit/publishUnit",
        method: "POST",
        responseType: "json",
        data: {
          ...obj,
          action: 0,
          hidden,
          lang_id: props.target.lang_id,
          slot: props.slot,
        },
      });
      if (res.code === 200) {
        Toast("success", "Removed Successfully!");
        let newArray = props.internalAds.filter(
          (item) =>
            parseInt(item.campaign_id) !== parseInt(data.campaign_id) &&
            item.hidden === hidden
        );
        props.setInternalAds(newArray);
        setShowRemoveAlert(false);
        setRemoveData({});
        props.fetchAds(0, props.target);
      } else {
        Toast("error", res?.data?.message);
      }
      setRemoveClicked(false);
    } catch (error) {
      console.error(error);
    }
  };
  function getHiddenvalue(targetValue) {
    const foundObject = lineItemData.find(
      (obj) => parseInt(obj.value) === parseInt(targetValue)
    );

    if (foundObject) {
      return foundObject.hidden;
    } else {
      return null; // Or handle the case when the value is not found
    }
  }

  const onSubmit = async (data) => {
    try {
      let res = await API({
        url: "/adunit/publishUnit",
        method: "POST",
        responseType: "json",
        data: { ...data, slot: props.slot },
      });

      if (res.code === 200) {
        Toast("success", "LineItem added Successfully!");
        setAdd(false);
        setSubmitClicked(false);
        setFormData(false);
        setFormSubmit(false);
        form1.reset();
        form1.reset();
        props.fetchAds(0, props.target);
        props.setInternalAds((prevAds) => [
          ...prevAds,
          {
            campaign_id: data.campaign_id,
            hidden: getHiddenvalue(data.campaign_id),
          },
        ]);
      } else {
        Toast("error", res.data.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const dummySubmit = async (data) => {
    setPreviewCampaignId(data.adName?.value)
    setMatchAdCodeAlert(await fetchMatchAdCodeAlert({campaign_id: data.adName?.value, lang_id: watchLang}))
    setSubmitClicked(true);
    let formData = {
      campaign_id: data.adName?.value,
      backfill: false,
      ad_type: "panel",
      action: 1,
      position: props.position,
      rotation: data.rotation ? 1 : 0,
      lang_id: watchLang,
      hidden: getHiddenvalue(data.adName?.value),
    };
    setFormData(formData);
  };
  const fetchAds = async () => {
    setSpinner(true);
    try {
      let res = await API({
        url: "/adunit/PositionalAds",
        method: "POST",
        responseType: "json",
        data: {
          target_filter: {
            lang_id: watchLang,
            state_id: watchState || "-1",
            district_id: watchDist || "-1",
            mandal_id: watchMandal || "-1",
            village_id: "-1",
            zone_id: watchZone || "-1",
          },
          position: props.position,
          backfill: props?.backfill ? props.backfill : false,
          slot: props.slot,
        },
      });
      if (res.code === 200) {
        setLineItemData(res.data?.final_campaigns);
        setExistingData(res.data?.alertLiNnames);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSpinner(false);
    }
  };
  const LanguageFilterChange = () => {
    setTarget_filter((prevState) => ({ ...prevState, lang_id: watchLang }));
    form1.setValue("zone_id", "");
    fetchZonesByLang(watchLang);
    if (props.from === 1) {
      fetchAds();
    }
    if (props.from >= 2) form1.setValue("state_id", "");
    if (props.from >= 3) {
      form1.setValue("district_id", "");
      setDistrictfilter([]);
    }
    if (props.from >= 4) {
      form1.setValue("mandal_id", "");
      setMandalfilter([]);
    }
    form1.setValue("adName", "");
  };

  const fetchZonesByLang = async (watchLang = 1) => {
    try {
      let zoneOptions = await API({
        url: "/location/getZones",
        method: "POST",
        responseType: "json",
        data: { lang_id: watchLang },
      });
      if (zoneOptions?.code === 200) {
        let zoneOptionsArr = [];
        for await (let item of zoneOptions.data) {
          const temp = { value: item.zone_id, label: `${item.zone_name}` };
          zoneOptionsArr.push(temp);
        }
        setZoneOptions(zoneOptionsArr);
      } else {
        setZoneOptions([]);
      }
    } catch (error) {
      console.error(error);
      setZoneOptions([]);
    }
  };

  const ZoneFilterChange = async () => {
    setTarget_filter((prevState) => ({ ...prevState, zone_id: +watchZone }));
    if (props.from === 5) {
      fetchAds();
    }
  };

  const StateFilterChange = async () => {
    if (watchState !== "-1" && watchState) {
      try {
        let res = await API({
          url: "/location/getDistrictsByStateId",
          method: "POST",
          responseType: "json",
          data: { states: [watchState], langs: [watchLang] },
        });
        if (res.code === 200) {
          let districts = [];
          for await (let item of res.data) {
            const temp = { value: item.dist_id, label: `${item.dist_name}` };
            districts.push(temp);
          }
          setDistrictfilter(districts);
          if (props.from >= 3) form1.setValue("district_id", "");
          if (props.from >= 4) {
            form1.setValue("mandal_id", "");
            setMandalfilter([]);
          }
          form1.setValue("adName", "");
          setTarget_filter((prevState) => ({
            ...prevState,
            state_id: watchState,
          }));
          if (props.from === 2) {
            fetchAds();
          }
        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  const DistrictFilterChanger = async () => {
    if (watchDist !== "-1" && watchDist) {
      try {
        let res = await API({
          url: "/location/getMandalsnew",
          method: "POST",
          responseType: "json",
          data: { districts: [watchDist], langs: [watchLang] },
        });
        if (res.code === 200) {
          let mandals = [];
          for await (let item of res.data) {
            const temp = {
              value: item.mandal_id,
              label: `${item.mandal_name}`,
            };
            mandals.push(temp);
          }
          setMandalfilter(mandals);
          if (props.from >= 4) form1.setValue("mandal_id", "");
          form1.setValue("adName", "");
          setTarget_filter((prevState) => ({
            ...prevState,
            district_id: watchDist,
          }));
          if (props.from === 3) {
            fetchAds();
          }
        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  const MandalFilterChange = async () => {
    setTarget_filter((prevState) => ({ ...prevState, mandal_id: watchMandal }));
    fetchAds();
  };

  useEffect(() => {
    if (props.internalAds.length > 0) {
      setDataFields();
    } else {
      setInternalAds([]);
    }
  }, [props.internalAds]);

  useEffect(() => {
    if (adIds.length > 0) fetchInternalAds();
  }, [adIds]);

  useEffect(() => {
    LanguageFilterChange();
  }, [watchLang]);
  useEffect(() => {
    if (
      props.from >= 2 &&
      target_filter.lang_id !== "-1" &&
      target_filter.state_id !== ""
    ) {
      StateFilterChange();
    }
  }, [watchState]);
  useEffect(() => {
    if (props.from >= 3 && target_filter.state_id !== "-1")
      DistrictFilterChanger();
  }, [watchDist]);
  useEffect(() => {
    if (props.from >= 4 && target_filter.district_id !== "-1")
      MandalFilterChange();
  }, [watchMandal]);
  useEffect(() => {
    if (props.from === 5)
      fetchZonesByLang(+watchLang);
  }, []);
  useEffect(() => {
    if (props.from === 5 && watchZone !== "-1")
      ZoneFilterChange();
  }, [watchZone]);

  return (
    <Modal show={props.show} onHide={handleClose}  centered className="popup-modal">
    <div className={"popup-container"}>
      <div className="popup-header">
        <h3>{props.from === 1 ? "Language" :props.from === 2 ? "State" :props.from === 3 ? "District" : props.from !== 'Backfill' ? props.from === 5 ? "Zone" : "Mandal" :"Backfill" } Ads</h3>
        <span className="close">
          <img src={CloseCrosssvg} onClick={handleClose} alt="Close" />
        </span>
      </div>
      <div className="popup-body">
        <div className="title-row">
          <h4>
            Ad Position: <b>#{props.position}</b>
          </h4>
          {props.from !== "Backfill" ? (
            <button onClick={() => setAdd(true)} className="add-line-item">
              + Add Line Item
            </button>
          ) : null}
        </div>

        {add ? (
          <div >
            <form className="form-container" onSubmit={form1.handleSubmit(dummySubmit)}>
              <div className="field-set">
                <label>Language</label>
                <select
                  name=""
                  id=""
                  {...form1.register("lang_id", { required: true })}
                >
                  {languageOptions.map((language) => {
                    return (
                      <option value={language.value} key={language.value}>
                        {language.label}
                      </option>
                    );
                  })}
                </select>
              </div>
              {props.from !== 5 ? <>
              {props.from >= 2 ? (
                <div className="field-set">
                  <label>State</label>
                  <select
                    name=""
                    id=""
                    {...form1.register("state_id", { required: true })}
                  >
                     <option value="">Select State</option>
                    {stateOptions
                      .filter((item) => item.lang_id === +watchLang)
                      .map((item) => {
                        return (
                          <option key={item.state_id} value={item.state_id}>
                            {item.state_name}
                          </option>
                        );
                      })}
                  </select>
                  {form1.formState.errors.state_id && (
                    <p className="text-red-600 my-0">State is Required</p>
                  )}
                </div>
              ) : null}
              {props.from >= 3 ? (
                <div className="field-set">
                  <label>District</label>
                  <select
                    name=""
                    id=""
                    {...form1.register("district_id", {
                      required: true,
                    })}
                  >
                                <option value="">Select District</option>
                    {districtfilter.map((district) => {
                      return (
                        <option value={district.value} key={district.value}>
                          {district.label}
                        </option>
                      );
                    })}
                  </select>
                  {form1.formState.errors.district_id && (
                    <p className="text-red-600 my-0">District is Required</p>
                  )}
                </div>
              ) : null}
              {props.from >= 4 ? (
                <div className="field-set">
                  <label>Mandal</label>
                  <select
                    name=""
                    id=""
                    {...form1.register("mandal_id", { required: true })}
                  >
                                <option value="">Select Mandal</option>

                    {mandalFilter.map((mandal) => {
                      return (
                        <option value={mandal.value} key={mandal.value}>
                          {mandal.label}
                        </option>
                      );
                    })}
                  </select>
                  {form1.formState.errors.mandal_id && (
                    <p className="text-red-600 my-0">Mandal is Required</p>
                  )}
                </div>
              ) : null}
              </> : null}
              {props.from === 5 ? (
                <div className="field-set">
                  <label>Zone</label>
                  <select
                    name=""
                    id=""
                    {...form1.register("zone_id", { required: true })}
                  >
                    <option value="">Select Zone</option>
                    {zoneOptions.map((zone) => {
                      return (
                        <option value={zone.value} key={zone.value}>
                          {zone.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : null}
              <div className="field-set">
                <label>Line Item</label>
                <Controller
                name="adName" // Name of the form field
                control={form1.control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="adName_"
                    placeholder={
                     "Select LineItem"
                    }
                   
                    options={lineItemData}
                    className="!w-80"
                    classNamePrefix="select"
                  />
                )}
              />
                {form1.formState.errors.adName && (
                  <p className="text-red-600 my-0">LineItem is Required</p>
                )}
              </div>
              <div className="field-set align-vcenter ml-10">
                <label for="rotn">
                  <input
                    defaultChecked={props.rotation === 1 ? true : false}
                    {...form1.register("rotation", { required: false })}
                    type="checkbox"
                    id="rotn"
                  />{" "}
                  Rotation
                </label>
              </div>
              <div className="field-set align-vcenter-row">
                <button className="btn-submit" type="submit">
                  <span>Submit</span>{" "}
                  <img src="images/angle_right.svg" alt="" />
                </button>
                <button
                  className="btn-cancel"
                  onClick={() => {
                    setAdd(false);
                    setSubmitClicked(false);
                    setFormData(false);
                    setFormSubmit(false);
                    form1.reset();
                  }}
                >
                  <span>Cancel</span>
                </button>
              </div>
            </form>
          </div>
        ) : null}
        <div className={"existing-list"}>
          {!loader
            ? internalAds?.map((item, index) => {
                return (
                  <>
                    <div key={index} className={"exist-card"}>
                      <div className="head-row">
                        <label className="local-internal"> {item.type}</label>
                        <label className="cpd-internal">{item.campaign_type}</label>
                        <label className="status">
                          {item.status === 2
                            ? "Running"
                            : `Scheduled for ${formatDateWithTime(
                                item.start_date
                              )}`}{" "}
                        </label>
                      </div>
                      <p>
                        {" "}
                        {item.campaign_name}
                        <span>
                          <img
                            onClick={() => {
                              setRemoveData({
                                position: props.position,
                                backfill: props.from === "Backfill",
                                campaign_id: item.campaign_id,
                                campaign_name: item.campaign_name,
                                ad_type: "panel",
                                action: 0,
                              });
                              setHidden(item.hidden);
                              setShowRemoveAlert(true);
                            }}
                            src={DeleteSvg}
                            alt="Delete"
                          />
                        </span>
                      </p>
                      <TargetPreview data={item} />
                      {item.hidden === 1 ? (
                        <span className="px-2 py-1 text-white absolute rounded-br-md  rounded-tl-md top-0 left-0 text-xs bg-green-700">
                          Hidden
                        </span>
                      ) : null}
                    </div>
                  </>
                );
              })
            : null}
        </div>
        <div>
          <Modal
            show={showRemoveAlert}
            onHide={() => {
              setShowRemoveAlert(false);
              setRemoveData({});
            }}
            backdrop="static"
            animation={false}
            dialogClassName="modal-30w"
            centered
          >
            <ModalHeader closeButton>
              <ModalTitle>
                <h3>Are you Sure ?(Remove Ad)</h3>
              </ModalTitle>
            </ModalHeader>
            <ModalBody>
              <div>
                {/* <h3>Are you sure ?</h3> */}
                {removeData.campaign_name ? (
                  <div>
                    <h6 className="capitalize">
                      LineItem: {removeData.campaign_name}
                    </h6>
                    <h6>Position: {removeData.position}</h6>
                  </div>
                ) : (
                  <div>
                    <h6 className="capitalize">
                      Ad Name: {`${removeData.ad_unit}`}
                    </h6>
                    <h6>Position: {removeData.position}</h6>
                  </div>
                )}
                {/* <JsonView
                data={removeData}
                shouldExpandNode={allExpanded}
              ></JsonView> */}
                <div className="d-flex gap-3 justify-content-end mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="button"
                    onClick={() => {
                      setShowRemoveAlert(false);
                      setRemoveData({});
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    type="submit"
                    onClick={() => {
                      setRemoveClicked(true);
                      removeFromPosition(removeData);
                    }}
                    disabled={removeClicked}
                  >
                    {removeClicked && (
                      <span
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {removeClicked ? "Removing..." : "Remove"}
                  </button>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </div>
        <div>
        <Modal
  show={submitClicked}
  onHide={() => {
    setSubmitClicked(false);
    setAdd(false);
    setFormData(false);
    setFormSubmit(false);
    props.fetchAds(0, props.target_filter);
    setPreviewCampaignId(null);
  }}
  backdrop="static"
  animation={false}
  dialogClassName="modal-fullwidth"
  size="xl"
  centered
>
  <ModalHeader closeButton className="border-bottom bg-light">
    <div className="d-flex align-items-center justify-content-between w-100">
      <ModalTitle className="d-flex align-items-center mb-0">
        <i className="fas fa-list-alt me-2 text-primary"></i>
        <h4 className="mb-0 text-dark fw-bold">Existing Lineitems Overview</h4>
      </ModalTitle>

      {/* Actions */}
      <div className="d-flex gap-2 ms-3">
        <button
          className="btn btn-outline-danger btn-sm px-3 d-flex align-items-center"
          type="button"
          onClick={() => {
            setSubmitClicked(false);
            setAdd(false);
            setFormData(false);
            setFormSubmit(false);
            props.fetchAds(0, props.target_filter);
            setPreviewCampaignId(null);
          }}
        >
          <i className="fas fa-times me-1"></i>
          Cancel
        </button>

        <button
          className="btn btn-primary btn-sm px-3 d-flex align-items-center position-relative"
          type="submit"
          onClick={() => {
            setFormSubmit(true);
            onSubmit(formData);
          }}
          disabled={formSubmit}
          style={{ minWidth: "120px" }}
        >
          {formSubmit && (
            <span
              className="spinner-border spinner-border-sm me-1"
              role="status"
              aria-hidden="true"
              style={{ width: "0.8rem", height: "0.8rem" }}
            ></span>
          )}
          <i className={`fas ${formSubmit ? "fa-spinner fa-spin" : "fa-check"} me-1`}></i>
          {formSubmit ? "Submitting..." : "Submit"}
        </button>
      </div>
    </div>
  </ModalHeader>

  <ModalBody className="p-4" style={{ maxHeight: "80vh", overflowY: "auto" }}>
    <div className="container-fluid">
      <div className="row">

        {/* Combined Lineitems & Alerts */}
        <div className="col-12 mb-4">
          <div className="card border-0 shadow-sm">
            <div
              className="card-header bg-gradient text-white d-flex align-items-center"
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              }}
            >
              <i className="fas fa-tags me-2"></i>
              <h5 className="mb-0 fw-semibold">Lineitems & Matching Alerts</h5>
              <span className="badge bg-light text-dark ms-auto">
                {existingData.length +
                  (matchAdCodeAlert?.dfp_lineitems_alerts?.length || 0) +
                  (matchAdCodeAlert?.networkAd_alerts?.length || 0)}{" "}
                items
              </span>
            </div>

            <div className="card-body p-3">

              <div className="row g-2">

                {/* === Existing Lineitems (Blue) === */}
                {existingData?.map((item, index) => (
                  <div key={`ex-${index}`} className="col-md-6 col-lg-4 d-flex">
                    <div
                      className="alert w-100 h-100 mb-2 border-0 shadow-sm d-flex align-items-center p-1"
                      style={{
                        backgroundColor: "#e3f2fd",
                        color: "#0d47a1",
                        fontWeight: 500,
                      }}
                    >
                      <i className="fas fa-database me-2"></i>
                      <span>{item.label}</span>
                      <span
                        className="badge ms-auto"
                        style={{ backgroundColor: "#bbdefb", color: "#0d47a1" }}
                      >
                        Existing
                      </span>
                    </div>
                  </div>
                ))}

                {/* === DFP Alerts (Yellow) === */}
                {matchAdCodeAlert?.dfp_lineitems_alerts?.map((item, index) => (
                  <div key={`dfp-${index}`} className="col-md-6 col-lg-4 d-flex">
                    <div
                      className="alert w-100 h-100 mb-2 border-0 shadow-sm d-flex align-items-center p-1"
                      style={{
                        backgroundColor: "#ede7f6",  // light violet
                        color: "#4a148c",  
                        fontWeight: 500,
                      }}
                    >
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      <span>
                        {item.campaign_name} ({item.ad_code}) — P{item.position} {slotOptions[item.slot]}
                      </span>
                      <span
                        className="badge ms-auto"
                        style={{ backgroundColor: "#d1c4e9", color: "#4a148c" }}
                      >
                        DFP Match
                      </span>
                    </div>
                  </div>
                ))}

                {/* === Network Ads Alerts (Red) === */}
                {matchAdCodeAlert?.networkAd_alerts?.map((item, index) => (
                  <div key={`net-${index}`} className="col-md-6 col-lg-4 d-flex">
                    <div
                      className="alert w-100 h-100 mb-2 border-0 shadow-sm d-flex align-items-center p-1"
                      style={{
                        backgroundColor: "#fff3cd",
                        color: "#856404",
                        fontWeight: 500,
                      }}
                    >
                      <i className="fas fa-exclamation-circle me-2"></i>
                      <span>
                        {item.ad_name} ({item.ad_code})
                        {item.position ? ` — P${item.position}` : ""}
                      </span>
                      <span
                        className="badge ms-auto"
                        style={{ backgroundColor: "#ffeeba", color: "#856404" }}
                      >
                        Network Match
                      </span>
                    </div>
                  </div>
                ))}

                {/* === NO DATA === */}
                {existingData.length === 0 &&
                  (matchAdCodeAlert?.dfp_lineitems_alerts?.length || 0) === 0 &&
                  (matchAdCodeAlert?.networkAd_alerts?.length || 0) === 0 && (
                    <div className="text-center py-4">
                      <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                      <h5 className="text-muted">No Lineitems Found</h5>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>

        {/* Preview Section */}
        {previewCampaignId && (
          <div className="col-12 mb-4">
            <div className="card border-0 shadow-sm">
              <div
                className="card-header bg-gradient text-white d-flex align-items-center"
                style={{
                  background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                }}
              >
                <i className="fas fa-eye me-2"></i>
                <h5 className="mb-0 fw-semibold">Lineitem Preview</h5>
                <small className="ms-auto opacity-75">
                  Campaign ID: {previewCampaignId}
                </small>
              </div>
              <div className="card-body p-3">
                <LineitemPreview campaign_id={previewCampaignId} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  </ModalBody>
</Modal>

        </div>
      </div>
    </div>
    </Modal>
  );
}
export default InternalAds;
